import { useState } from "react";

export function useConfirmDialog() {
  const [open, setOpen] = useState(false);
  const [config, setConfig] = useState({
    title: "",
    message: "",
    onConfirm: null,
  });

  const openDialog = ({
    title,
    message,
    onConfirm,
    confirmText,
    cancelText,
  }) => {
    setConfig({
      title,
      message,
      onConfirm,
    });
    setOpen(true);
  };

  const closeDialog = () => {
    setOpen(false);
    setConfig({
      title: "",
      message: "",
      onConfirm: null,
    });
  };

  return {
    dialogOpen: open,
    dialogConfig: config,
    openDialog,
    closeDialog,
  };
}
